import { SEARCH_PRODUCTS_API, SearchProductsAPI, SearchProductsGetRequest, } from 'components/discovery/shared/search/api/search-products-api.js'
import { FilterAttributesParser } from 'components/discovery/shared/search/parsers/filter-attributes-parser.js'
import { SearchProductsParser } from 'components/discovery/shared/search/parsers/search-products-parser.js'
import { SearchResultsResponse } from 'components/discovery/shared/search/typing/search-results.js'
import { inject } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'


export class SearchProductsDatafetcher {

  @inject(SEARCH_PRODUCTS_API)
  private api!: SearchProductsAPI

  private filterAttributesParser: FilterAttributesParser = new FilterAttributesParser()
  private searchProductParser: SearchProductsParser = new SearchProductsParser()

  lastRequest: SearchProductsGetRequest | null

  constructor() {
    this.lastRequest = null
  }

  async search(request: SearchProductsGetRequest, isLoading: boolean) {
    if (this.lastRequest && isLoading) {
      this.lastRequest.controller.abort()
    }

    this.lastRequest = request

    try {
      const response = (await this.api.search(request))

      let parsedSearchResults: SearchResultsResponse
      try {
        parsedSearchResults = this.searchProductParser.parseSearchResultsResponse(response.body)
      } catch (error) {
        // error must be passed to sentry.
        console.error(error)
        return
      }

      const parsedFilterAttributes = this.filterAttributesParser.parseFilterAttributes(response.body)
      if (this.filterAttributesParser.filterAttributeParseResultHasError(parsedFilterAttributes)) {
        // error must be passed to sentry.
        console.error(parsedFilterAttributes.error)
        return
      }

      return {
        searchResults: parsedSearchResults,
        attributes: parsedFilterAttributes
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e)
      console.warn(`fetching ${request.endpointUrl.toString()} failed`)
      return
    }
  }
}
